import { render, staticRenderFns } from "./InventoryProducts.vue?vue&type=template&id=6294fc0c&"
import script from "./InventoryProducts.vue?vue&type=script&lang=js&"
export * from "./InventoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./InventoryProducts.vue?vue&type=style&index=0&id=6294fc0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports